import { render, staticRenderFns } from "./elementCollection.vue?vue&type=template&id=566aa58c&scoped=true&"
import script from "./elementCollection.vue?vue&type=script&lang=js&"
export * from "./elementCollection.vue?vue&type=script&lang=js&"
import style0 from "./elementCollection.vue?vue&type=style&index=0&id=566aa58c&scoped=true&lang=scss&"
import style1 from "./elementCollection.vue?vue&type=style&index=1&id=566aa58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566aa58c",
  null
  
)

export default component.exports